import * as _ from 'underscore';

import * as React from 'react';
import { CommonStyles } from '../CommonStyles';

/**
 * A module containing various parts of a Select component. This will eventually replace tb:select
 */
export module Select {

  export class ListPanel extends React.PureComponent<ListPanel.Props, any> {

    public static displayName = 'SelectListPanel';
    public static element = React.createFactory(ListPanel);

    public render() {
      const menuItems =
        _.map(this.props.items, (menuItem: ListPanel.ListPanelItem) =>
          ListPanel.Item.element({
            key: menuItem.id,
            id: menuItem.id,
            text: menuItem.text,
            selected: menuItem.id === this.props.selectedItemId,
            onItemSelected: this.props.onItemSelected,
            isDisabled: menuItem.isDisabled
          })
        );

      return React.createElement('div', {
        style: _.extend({
          backgroundColor: CommonStyles.Colors.White
        }, this.props.style)
      }, menuItems);
    }

  }

  export module ListPanel {

    export class Item extends React.PureComponent<Item.Props, any> {

      public static displayName = 'ListPanelItem';
      public static element = React.createFactory(Item);

      private boundOnItemSelected: () => any;

      constructor(props: Item.Props) {
        super(props);
        this.boundOnItemSelected = this.onItemSelected.bind(this);
      }

      public render() {
        const menuItemClassNames = _.compact(['tb-popup-menu-item', this.props.isDisabled && 'tb-disabled']).join(' ');
        const menuItemText = React.createElement('span', { className: 'tb-menu-item-text' }, this.props.text);
        return React.createElement('div', {
          className: menuItemClassNames,
          'data-tb-test-id': this.props.id,
          onClick: this.boundOnItemSelected
        } as React.HTMLAttributes<HTMLDivElement>,
        this.bullet(), menuItemText);
      }

      private onItemSelected() {
        if (this.props.isDisabled) {
          return;
        }
        this.props.onItemSelected(this.props.id);
      }

      private bullet() {
        return React.createElement('span', {
          style: {
            paddingRight: CommonStyles.Sizes.DefaultSpace,
            visibility: this.props.selected ? 'visible' : 'hidden',
            fontSize: '20px',
            verticalAlign: 'middle'
          }
        }, '•');
      }

    }

    export module Item {
      export interface Props {
        id: string;
        text: string;
        selected: boolean;
        isDisabled?: boolean;
        onItemSelected(id: string): any;
      }
    }

    export interface Props {
      items: ListPanelItem[];
      onItemSelected(itemId: string): any;
      selectedItemId?: string;
      style?: any;
    }

    export interface ListPanelItem {
      id: string;
      text: string;
      isDisabled?: boolean;
    }

  }

  export class Button extends React.PureComponent<Button.Props>{

    public static displayName = 'SelectButton';
    public static element = React.createFactory(Button);

    public render() {
      const menuButtonClassNames = _.compact([
        'tb-popup-menu-button',
        'tb-select-button',
        this.props.isDisabled && 'tb-disabled'
      ]).join(' ');

      return React.createElement('div', { className: menuButtonClassNames, style: this.props.style },
        React.createElement('div', { className: 'tb-text' }, this.props.children),
        React.createElement('div', { className: 'tb-line' }),
        React.createElement('div', { className: 'tb-arrow' })
      );
    }
  }

  export module Button {
    export interface Props extends React.Props<Button> {
      style?: React.CSSProperties;
      isDisabled?: boolean;
    }
  }
}
